import { Controller } from "@hotwired/stimulus"

// Desktop: the sidebar is always on screen, expanded or collapsed to icons,
// and that choice is remembered. Phones: it's hidden and slides in over the
// page from the navbar menu button; tapping outside it closes it. Phone
// open/close is never remembered, so it can't get stuck hidden.
const MOBILE_QUERY = "(max-width: 768px)"

export default class extends Controller {
  static targets = ["sidebar", "label", "backdrop"]

  connect() {
    const stored = localStorage.getItem("sidebarExpanded")
    this.expanded = stored === null ? true : stored === "true"
    this.mobileOpen = false
    this.mql = window.matchMedia(MOBILE_QUERY)

    // Suppress transition on initial load to prevent layout jump
    const sidebar = this.sidebarTarget
    sidebar.style.transition = "none"
    this._apply()
    // Force a reflow then restore the CSS transition
    sidebar.offsetHeight // eslint-disable-line no-unused-expressions
    sidebar.style.transition = ""

    // Remove the early-paint helper class now that Stimulus owns the state
    document.documentElement.classList.remove("sb-collapsed")

    // The navbar menu button lives outside this controller's element.
    this._open = () => { this.mobileOpen = true; this._apply() }
    this.menuButton = document.querySelector("[data-sidebar-open]")
    this.menuButton?.addEventListener("click", this._open)

    this._onBreakpoint = () => { this.mobileOpen = false; this._apply() }
    this.mql.addEventListener("change", this._onBreakpoint)
  }

  disconnect() {
    this.menuButton?.removeEventListener("click", this._open)
    this.mql?.removeEventListener("change", this._onBreakpoint)
  }

  toggle() {
    if (this._isMobile()) {
      this.mobileOpen = !this.mobileOpen
    } else {
      this.expanded = !this.expanded
      localStorage.setItem("sidebarExpanded", this.expanded)
    }
    this._apply()
  }

  close() {
    this.mobileOpen = false
    this._apply()
  }

  _isMobile() {
    return this.mql.matches
  }

  _apply() {
    const sidebar = this.sidebarTarget
    // Phones always show full labels when open.
    const expanded = this._isMobile() ? true : this.expanded
    sidebar.classList.toggle("sidebar--expanded", expanded)
    sidebar.classList.toggle("sidebar--collapsed", !expanded)

    const open = this._isMobile() && this.mobileOpen
    sidebar.classList.toggle("sidebar--mobile-open", open)
    if (this.hasBackdropTarget) this.backdropTarget.classList.toggle("sidebar-backdrop--visible", open)
  }
}
